import { render } from "./ObjectiveForm.vue?vue&type=template&id=04e66470&scoped=true"
import script from "./ObjectiveForm.vue?vue&type=script&lang=js"
export * from "./ObjectiveForm.vue?vue&type=script&lang=js"

import "./ObjectiveForm.vue?vue&type=style&index=0&id=04e66470&lang=scss&scoped=true"
import "./ObjectiveForm.vue?vue&type=style&index=1&id=04e66470&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e66470"]])

export default __exports__